/**
 * D146: how the room over the map is shared out. Pure, so the World screen measures and this
 * decides, and both can be asserted without a DOM.
 */

/** The floating panels over the map all sit clear of its edges by the same margin. */
export const OVER_MAP = 8;
